/**
 * STANDARDOWE BADGES - jeden styl na całą platformę
 * Używane: PublicStud, PublicKennel, PublicDog, karty psów
 */

// Format tytułu do wyświetlenia
export const formatTitle = (title) => {
  if (!title) return '';
  return title
    .replace('ch_pl', 'CH.PL')
    .replace('ch_int', 'C.I.B.')
    .replace('ch_club', 'CH.KLUB')
    .replace('ch_youth', 'MŁ.CH.PL')
    .replace('ch_', 'CH.')
    .replace('_', ' ')
    .toUpperCase();
};

// Format szkolenia do wyświetlenia
export const formatTraining = (training) => {
  if (!training) return '';
  return training.toUpperCase();
};

// Badge tytułu wystawowego - ZŁOTY
export const TitleBadge = ({ title, className = '' }) => (
  <span className={`px-2.5 py-1 bg-amber-500/20 text-amber-400 rounded-full text-xs font-semibold border border-amber-500/30 ${className}`}>
    {formatTitle(title)}
  </span>
);

// Badge szkolenia/certyfikatu - NIEBIESKI
export const TrainingBadge = ({ training, className = '' }) => (
  <span className={`px-2.5 py-1 bg-blue-500/20 text-blue-400 rounded-full text-xs font-semibold border border-blue-500/30 ${className}`}>
    {formatTraining(training)}
  </span>
);

// Badge badania zdrowotnego - ZIELONY
export const HealthBadge = ({ test, className = '' }) => (
  <span className={`px-2.5 py-1 bg-emerald-500/20 text-emerald-400 rounded-full text-xs font-semibold border border-emerald-500/30 ${className}`}>
    {test}
  </span>
);

// Badge organizacji (ZKwP, FCI) - BIAŁY/SZARY
export const OrgBadge = ({ org, className = '' }) => (
  <span className={`px-2.5 py-1 bg-white/10 text-white rounded-full text-xs font-semibold border border-white/20 ${className}`}>
    {org}
  </span>
);

// Komponent wyświetlający wszystkie badges psa/reproduktora
export const DogBadges = ({ 
  titles = [], 
  training = [], 
  healthTests = [],
  maxTitles = 3,
  maxTraining = 2,
  maxHealth = 3,
  className = ''
}) => {
  // Parse health tests if string
  const healthArray = typeof healthTests === 'string' 
    ? healthTests.split(',').map(t => t.trim()).filter(Boolean)
    : (Array.isArray(healthTests) ? healthTests : []);

  // Parse titles if string
  const titlesArray = typeof titles === 'string'
    ? titles.split(',').map(t => t.trim()).filter(Boolean)
    : (Array.isArray(titles) ? titles : []);

  // Parse training if string
  const trainingArray = typeof training === 'string'
    ? training.split(',').map(t => t.trim()).filter(Boolean)
    : (Array.isArray(training) ? training : []);

  const hasAnyBadge = titlesArray.length > 0 || trainingArray.length > 0 || healthArray.length > 0;
  
  if (!hasAnyBadge) return null;

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {/* Tytuły wystawowe - złote */}
      {titlesArray.slice(0, maxTitles).map((title, i) => (
        <TitleBadge key={`t-${i}`} title={title} />
      ))}
      {/* Szkolenia - niebieskie */}
      {trainingArray.slice(0, maxTraining).map((tr, i) => (
        <TrainingBadge key={`tr-${i}`} training={tr} />
      ))}
      {/* Badania zdrowotne - zielone */}
      {healthArray.slice(0, maxHealth).map((test, i) => (
        <HealthBadge key={`h-${i}`} test={test} />
      ))}
    </div>
  );
};

export default DogBadges;
